import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PanVerificationResult} from '../pan-verification-status.resolver';
import {UnprocessableEntityError} from '../../../errors/UnprocessableEntityError';
import {ActivatedRoute} from '@angular/router';
import {BadRequestError} from '../../../errors/BadRequestError';
import {InvitationService} from '../../../service/invitation.service';
import {Keys, StorageService} from '../../../service/storage.service';

@Component({
    selector: 'app-pan-verification',
    templateUrl: './pan-verification.component.html',
    styleUrls: ['./pan-verification.component.scss', '../accept-invitation.component.css', '../../../../assets/styles/form-styles.css']
})
export class PanVerificationComponent implements OnInit {
    @Input()
    inviteeName: string;

    @Input()
    pan: string;

    @Input()
    invitedByName: string;

    @Input()
    panVerificationResult: PanVerificationResult;

    @Output()
    panVerified = new EventEmitter();

    error: Error;
    isLoading: boolean;

    constructor(private invitationService: InvitationService, private activatedRoute: ActivatedRoute,
                private storageService: StorageService) {
    }

    ngOnInit(): void {
        this.error = this.panVerificationResult.error;
    }

    public async verifyPan(name: string): Promise<void> {
        this.setLoading(true);
        try {
            const inviteId = this.activatedRoute.snapshot.params.id;
            const token = await this.invitationService.verifyPan(inviteId, name);
            this.storageService.saveItem(Keys.TOKEN, token);
            this.panVerified.emit(token);
        } catch (error) {
            this.error = error;
        } finally {
            this.setLoading(false);
        }
    }

    public nameMismatch(): boolean {
        return this.error instanceof UnprocessableEntityError;
    }

    public invalidPan(): boolean {
        return this.error instanceof BadRequestError;
    }

    public unknownError(): boolean {
        return !this.nameMismatch() && !this.invalidPan();
    }

    setLoading(isLoading: boolean) {
        this.isLoading = isLoading;
    }
}
